import { render, staticRenderFns } from "./PagedCartItems.vue?vue&type=template&id=232a3512&"
import script from "./PagedCartItems.vue?vue&type=script&lang=js&"
export * from "./PagedCartItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports